import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Index from './index'
import myOrderOperations from '../../../redux/MyOrder/operations';
import myOrderSelectors from '../../../redux/MyOrder/selectors';

const MultiFileUploadContainer = (props: any) => {

  const dispatch = useDispatch();
  const [deletedFile,setDeletedFile] = useState(0)
  const [fileList, setFileList] = useState<any>([]);
  const [uploadClickId, setUploadClickId] = useState<any>('');
  const dispatchGetUploadedBlobUrlList = myOrderOperations.dispatchGetUploadedBlobUrlList(dispatch)
  const dispatchSetUploadedBlobUrlList = myOrderOperations.dispatchSetUploadedBlobUrlList(dispatch)
  const dispatchSetUploadFilesComplete = myOrderOperations.dispatchSetUploadFilesComplete(dispatch)
  const dispatchSetUploadedFileDetails = myOrderOperations.dispatchSetUploadedFileDetails(dispatch)
  const dispatchSetOrderDetails = myOrderOperations.dispatchSetOrderDetails(dispatch)

  const {
    orderDetails,
    isUploadComplete,
    BlobUrlListObj
  }: any = useSelector(
    (state: any) => ({
      orderDetails: myOrderSelectors.orderDetails(state),
      isUploadComplete: myOrderSelectors.isUploadComplete(state),
      BlobUrlListObj: myOrderSelectors.BlobUrlListObj(state)
    })
  )

  useEffect(() => {
    if (isUploadComplete) {
      props?.setIsLoading(false);
      let uploadErrArr = [...(props.uploadErrMsg ?? [])];
      uploadErrArr[uploadClickId] = ''
      props?.setUploadErrMsg(uploadErrArr)

    }
  }, [isUploadComplete])

  useEffect(() => {
    if (BlobUrlListObj.hasOwnProperty('id')) {
      orderDetails.attachmentUrlList = BlobUrlListObj?.BlobUrlList
      dispatchSetOrderDetails(orderDetails);
    }

  }, [JSON.stringify(BlobUrlListObj.BlobUrlList)]);
  const actionColumn = useSelector(
    (state: any) => state.CustomerMyOrder.actionValue
  );

  useEffect(()=>{
    if(orderDetails?.attachmentFileObjList?.length > 0){
      let arr = []
      arr[0] = [...(orderDetails.attachmentFileObjList ?? [])]
      setFileList(arr)
    }

  },[JSON.stringify(orderDetails?.attachmentFileObjList)])

  const onAddAttachments = (e: any, index: any = 0) => {
    dispatchSetUploadFilesComplete(false);
    if(!isUploadComplete){
    dispatchSetUploadedBlobUrlList({ id: index, fileList: [] })
    }
    props?.setUploadErrMsg([]);
    let fileListarr: any[] = e.target.files;
    const data: any[] = [];
    for (let i = 0; i < fileListarr.length; i++) {
      data.push(fileListarr[i]);
    }
    let arr: any[] = [...fileList];
    if (fileList?.[index]?.length > 0) {
      arr[index] = [...fileList[index], ...data]
    } else {
      arr[index] = [...data]
    }
    setFileList(arr)
  }

  const onDeleteAttachment = (_item: any, fileIndex: any, vehicleIndex: any = 0) => {
    setDeletedFile(deletedFile + 1)
    dispatchSetUploadFilesComplete(false);
    dispatchSetUploadedBlobUrlList({ id: vehicleIndex, fileList: [] });
    props?.setUploadErrMsg([]);
    fileList[vehicleIndex]?.splice(fileIndex, 1);
    const data: any[] = [];
    for (let i = 0; i < fileList[vehicleIndex].length; i++) {
      data.push(fileList[vehicleIndex][i]);
    }
    let arr: any[] = [...fileList];
    arr[vehicleIndex] = [...data]
    setFileList(arr)
  }

  const onUploadClick = (event: any, index: any = 0) => {
    let uploadedFile: any = []
    function getUniqueListBy(arr: any, key: any) {
      return [...new Map(arr.map((item: any) => [item[key], item])).values()]
    }

    if (fileList[index]?.length > 0) {
      fileList[index] = getUniqueListBy(fileList[index], 'name')
      fileList[index]?.forEach((x: any) => {
        const extensionList = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf', 'docx', 'xlsx','heif','hevc'];
        const path = x.name.split('/');
        const fileName = path[path.length - 1];
        const indexExt = fileName.lastIndexOf('.');
        const extension = fileName.slice(indexExt + 1);
        if (extensionList.includes(extension.toString().toLowerCase())) {
          uploadedFile.push(x)
        }
      })
    }
    fileList[index] = uploadedFile;
    const fileavailablity = () => {
      event.preventDefault();
      setUploadClickId(event.currentTarget.id);
      dispatchSetUploadFilesComplete(false);
      props?.setAttachmentBtnClicked(false);
      props?.setIsLoading(true);
      const formData = new FormData();
      formData.append('ContainerFolderName', 'Order_Request_Attachments/' + orderDetails.directoryName);
      let fileArray = fileList[index];
      for (let i = 0; i < fileArray.length; i++) {
        formData.append('Files', fileArray[i]);
      }
      dispatchSetUploadedFileDetails(fileList[index]);
      dispatchGetUploadedBlobUrlList({ id: index, fileList: formData });
    }
    let fileCount = 0;
    let availableCount = 0;
    let counting = 0;
    if (orderDetails?.attachments?.length) {
      for (let i = 0; i < orderDetails?.attachments?.length; i++) {
        for (let j = 0; j < fileList[index]?.length; j++) {
          if (orderDetails?.attachments[i].fileName == fileList[index][j].name) {
            availableCount = availableCount + 1
          }
        }
        if (availableCount) {
          counting = (availableCount > fileList[index]?.length) ? (availableCount - fileList[index]?.length) : (fileList[index]?.length - availableCount)
          fileCount = counting
        }
        if (!counting && deletedFile) {
          fileavailablity()
        }
      }
    } else {

      if (fileList[index]) {
        fileCount = (fileList[index]?.length)
      } else {
        fileCount = 0
      }
    }
    let uploadErrArr = [...props.uploadErrMsg];
    if (fileCount > 0 && fileCount <= 5) {
      let totalSize = 0;
      let attachmentSize = 0;
      let fileListSize = 0;
      let orderAttachmentSize = 0;
      fileList[index].forEach((x: any) => {
        fileListSize = fileListSize + x.size || 0;
      })
      if (orderDetails?.attachmentFileObjList?.length) {
        orderDetails?.attachmentFileObjList?.forEach((x: any) => {
          orderAttachmentSize = orderAttachmentSize + x.size || 0;
        })
        attachmentSize = (orderAttachmentSize > fileListSize) ? (orderAttachmentSize - fileListSize) : (fileListSize - orderAttachmentSize)
      }
      if (attachmentSize) {
        totalSize = (attachmentSize > fileListSize) ? (attachmentSize - fileListSize) : (fileListSize - attachmentSize)
      }
      else {
        totalSize = fileListSize;
      }

      if (totalSize <= 5000000) {
        fileavailablity()
      } else {
        uploadErrArr[index] = 'Please Upload files without exceeding maximum size of 5MB'
      }
    }
    else if (fileCount > 5) {
      uploadErrArr[index] = 'Please Upload files without exceeding maximum limit of 5 files'
    }
    else if (fileList?.length > 0 && orderDetails?.attachments?.length && !deletedFile) {
      uploadErrArr[index] = "All files are uploaded try to add new files"
      const formData = new FormData();
      formData.append('ContainerFolderName', 'Order_Request_Attachments/' + orderDetails.directoryName);
      dispatchSetUploadedFileDetails(fileList[index]);
      dispatchGetUploadedBlobUrlList({ id: index, fileList: formData });
    }
    else {
      if (fileList[index]) {
        let arr: any[] = [...fileList];
        arr[index] = []
        setFileList(arr);
      }
      setUploadClickId(event.currentTarget.id);
      if (!deletedFile) {
        uploadErrArr[index] = "Choose at least 1 file to upload"
        const formData = new FormData();
        formData.append('ContainerFolderName', 'Order_Request_Attachments/' + orderDetails.directoryName);
        dispatchSetUploadedFileDetails(fileList[index]);
        dispatchGetUploadedBlobUrlList({ id: index, fileList: formData });
      }
    }
    props?.setUploadErrMsg(uploadErrArr)
    orderDetails.attachmentFileObjList = fileList[index];
    if (orderDetails?.attachmentFileObjList?.length == 0) {
      for (let i = 0; i < orderDetails?.requests?.length; i++) {
        orderDetails.requests[i].attachments = [];
        orderDetails.requests[i].linkedAttachmentList = [];
      }
    }
    dispatchSetOrderDetails(orderDetails)
    setDeletedFile(0)
  }

  return <Index
    onUploadClick={onUploadClick}
    onAddAttachments={onAddAttachments}
    onDeleteAttachment={onDeleteAttachment}
    setFileList={setFileList}
    fileList={fileList}
    id={props?.id}
    noFiles={props?.noFiles}
    multiple={props?.multiple}
    index={props?.index}
    uploadErrMsg={props?.uploadErrMsg}
    actionColumn= {actionColumn}
    data-attribute={props?.['data-attribute']}
  />
}

export default MultiFileUploadContainer
